import providerService from '../../../services/provider/ProviderService';
import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            search: "",
            headers: [{
                    text: 'Nombre',
                    sortable: false,
                    value: "name"
                },
                {
                    text: 'Nit',
                    sortable: false,
                    value: "fiscalNumber"
                }, {
                    text: 'Estado',
                    sortable: false,
                    value: "active"
                }
            ],
            itemsData: [],
            nroRows: 0
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.searchProviders();
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        searchProviders() {
            providerService.getProviders().then(response => {
                this.itemsData = response.data;
                this.nroRows = response.data.length;
            })
        },
        getLenght() {
            return this.nroRows;
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase();
            return items.filter(row => filter(row["name"], search));
        }
    }
};
